/**
 * A symptom type for the SymptomLike model.
 */
class FindingType {
  static PAIN: FindingType;
  static RASH: FindingType;
  static SWELLING: FindingType;

  private static _values: FindingType[] = [];
  private static _lookup: Map<string, FindingType> = new Map();

  static fromTag(tag?: string) {
    const findingType = FindingType._lookup.get(tag || '');
    if (findingType === undefined) {
      throw new Error('Not a valid FindingType.key: ' + tag);
    }
    return findingType;
  }

  static values(): FindingType[] {
    return [...FindingType._values];
  }

  // ---

  readonly tag: string;
  readonly label: string;
  readonly plural: string;

  constructor(tag: string, label: string, plural: string) {
    this.tag = tag;
    this.label = label;
    this.plural = plural;
    FindingType._values.push(this);
    FindingType._lookup.set(tag, this);
  }

  get labelLower() {
    return this.label.toLowerCase();
  }

  get pluralLower() {
    return this.plural.toLowerCase();
  }

  toString() {
    return '<SymptomType: ' + this.label + '>';
  }
}

FindingType.PAIN = new FindingType('pain', 'Pain', 'Pains');
FindingType.RASH = new FindingType('skin', 'Rash', 'Rashes');
FindingType.SWELLING = new FindingType('dist', 'Swelling', 'Swellings');

export { FindingType };
